const data = {
  func: {},
  style: {},
  data: {
    getData: {
      data: {
        data: [
          {
            title: "API对接采购供应链解决方案",
            subtitle:
              "提高通用物资集采率及采购效率。解决管理多个供应商的合规风控问题，让采购规范透明，降低人力成本，采购价格统一",
            bg:
              "https://img10.360buyimg.com/imagetools/jfs/t1/152071/39/1896/2222572/5f8163bdE38ca6281/838f07a5bc89c511.png",
            link: "",
          },
          {
            title: "多场景全覆盖接入型解决方案",
            subtitle:
              "提供内部采购延伸多场景的接入型解决方案：办公集采、员工福利、市场活动、虚拟业务、渠道奖励",
            bg:
              "https://img11.360buyimg.com/imagetools/jfs/t1/116187/33/19805/2200198/5f8163beEdc5492d6/71408b6de18ad1e7.png",
            link: "",
          },
          {
            title: "多行业全覆盖接入型解决方案",
            subtitle:
              "金融保险、制造、大交通、运营商、能源、互联网、建筑地产等全行业覆盖提供对应解决方案",
            bg:
              "https://img10.360buyimg.com/imagetools/jfs/t1/148379/26/10306/2195886/5f8163c0E9dac57b4/7bc303015b2816e7.png",
            link: "",
          },
        ],
      },
      filter: "() => {}",
    },
  },
};
export default data;
